import { PromptHistoryDialog as GenericPromptHistoryDialog } from "@/components/ui/prompt-history-dialog";
import {
  useAgentPromptHistory,
  useRollbackAgentPrompt,
} from "@/features/agents/hooks/useAgents";

interface Props {
  agentId: string;
  currentPrompt: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Wrapper que liga o dialog generico aos hooks especificos de agente.
 */
export function PromptHistoryDialog({
  agentId,
  currentPrompt,
  open,
  onOpenChange,
}: Props) {
  const history = useAgentPromptHistory(open ? agentId : "");
  const rollback = useRollbackAgentPrompt(agentId);

  return (
    <GenericPromptHistoryDialog
      resourceLabel="agente"
      versions={history.data ?? []}
      isLoading={history.isLoading}
      currentPrompt={currentPrompt}
      onRollback={(version) => rollback.mutateAsync({ version })}
      isRollingBack={rollback.isPending}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
}
